export { default as stateFromHTML } from './stateFromHTML';


//////////////////
// WEBPACK FOOTER
// ../draft-js-import-html/esm/main.js
// module id = 2052
// module chunks = 22